// Step 25 — recent activity feed.
//
// Composes two AUTHORITATIVE streams that already exist:
//   - DealSituationSnapshot (Step 12, workspace-scoped audit log)
//   - Notification (Step 14, recipient-scoped)
//
// AIActivityPage already renders these individually; the Command
// Center shows a compact interleaved chronology sorted by real
// timestamps. Any row without a parseable timestamp is dropped
// rather than sorted with a fabricated fallback.

import { Link } from "react-router-dom";

import { AIEmpty, AISection } from "../AIPrimitives";
import { commandActivityRows } from "./helpers";

function _fmt(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("sv-SE", {
      dateStyle: "short",
      timeStyle: "short",
    });
  } catch {
    return String(iso);
  }
}

export default function AICommandActivity({
  snapshots,
  notifications,
  workspaceId,
  limit = 12,
}) {
  const rows = commandActivityRows({ snapshots, notifications }).slice(0, limit);
  if (rows.length === 0) {
    return (
      <AISection title="Senaste aktivitet">
        <AIEmpty
          title="Ingen aktivitet registrerad ännu"
          hint="Aktivitet visas när deal_situation-snapshots eller notiser skapas."
        />
      </AISection>
    );
  }
  return (
    <AISection
      title="Senaste aktivitet"
      right={
        <Link
          to={`/deals/${workspaceId}/activity`}
          className="qai-page-section-link"
        >
          Hela aktivitetsloggen →
        </Link>
      }
    >
      <ul className="qai-command-activity">
        {rows.map((r) => (
          <li
            key={r.key}
            className="qai-command-activity-row"
            data-kind={r.kind}
          >
            <span className="qai-command-activity-when">{_fmt(r.as_of)}</span>
            <span className="qai-command-activity-title">{r.title}</span>
            {r.kind === "snapshot" && r.counters && (
              <span className="qai-command-activity-meta">
                buyers={r.counters.buyer_count ?? "—"} · open={r.counters.open_items_count ?? "—"}
                · silence={r.counters.silence_signal_count ?? "—"} · gaps={r.counters.preparedness_gap_count ?? "—"}
              </span>
            )}
            {r.kind === "notification" && (
              <span
                className="qai-command-activity-meta"
                data-read={r.is_read ? "true" : "false"}
              >
                {r.notification_type || "notis"}
                {r.is_read ? " · läst" : " · oläst"}
              </span>
            )}
            <span className="qai-command-activity-source">
              {r.source.source_type} #{r.source.source_id}
            </span>
          </li>
        ))}
      </ul>
    </AISection>
  );
}
